import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card w-lg-100 bg-white rounded shadow-sm mx-auto row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light my-2" }, "Trainee Information")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body p-5" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "pt-7" }
const _hoisted_8 = { id: "trainee_profile" }
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"\"><button type=\"button\" class=\"btn btn-success btn-sm mb-1 mx-2\" data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_add_industry\"><i class=\"fas fa-check\"></i> Approve </button><button type=\"button\" class=\"btn btn-danger btn-sm mb-1\" data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_add_industry\"><i class=\"fas fa-window-close\"></i> Reject </button></div>", 1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_12 = { class: "profile-info pt-1 pb-1" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "thumbnail text-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-bold d-block pt-1" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user fa-10x" })
    ])
  ])
], -1)
const _hoisted_15 = { class: "col-sm-9" }
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Name")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gender")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Father Name")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mother Name")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "National ID")
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Birth Certificate Number")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, ": ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date of Birth")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Home District")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Present Address")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent Address")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Present District")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Present Upazilla")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent District")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent Upazilla ")
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Home Upazilla")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Post Code ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Ethnic Group")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Is Employed? ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Is Physically Challenged?")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Remarks")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mobile")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Alternative Mobile")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Religion")
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Passing Year")
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Personal Monthly Income")
], -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Highest Class Completed")
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Attendance Percentage ")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", null, "98.61% (as of 72)", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Years of Experience")
], -1)
const _hoisted_49 = { class: "block" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark my-3" }, "Course Information", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_52 = { class: "table-responsive mb-2" }
const _hoisted_53 = { class: "table" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Sector name")
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Course name")
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Location")
], -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Partner")
], -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Training Institute")
], -1)
const _hoisted_59 = { class: "block" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark my-3" }, "Family Information", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_62 = { class: "table-responsive mb-2" }
const _hoisted_63 = { class: "table" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mother's Education Level")
], -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Mother's Occupation")
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Father's Education Level")
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Father's Occupation")
], -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", null, ": Business", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Family Annual Income")
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Number of Siblings")
], -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Have family owned home?")
], -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Have family owned land?")
], -1)
const _hoisted_73 = { class: "block" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-dark my-3" }, "Bank Information", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_76 = { class: "table-responsive mb-2" }
const _hoisted_77 = { class: "table" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Account Type")
], -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Bank Name")
], -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", null, ": Dhaka Bank", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Branch Name")
], -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", null, ": Mirpur", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Routing No")
], -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", null, ": 5", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Account Numbe")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("h2", null, "Profile of: " + _toDisplayString(_ctx.traineeInfos.name), 1),
                  _hoisted_10
                ]),
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("table", _hoisted_17, [
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_18,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.name), 1),
                              _hoisted_19,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.gander), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_20,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.father_name), 1),
                              _hoisted_21,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.mother_name), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_22,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.nid), 1),
                              _hoisted_23,
                              _hoisted_24
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_25,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.date_of_birth), 1),
                              _hoisted_26,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.home_district), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_27,
                              _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfos.present_address), 1),
                              _hoisted_28,
                              _createElementVNode("td", null, " : " + _toDisplayString(_ctx.traineeInfos.permanent_address), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_29,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.present_districts), 1),
                              _hoisted_30,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.present_upazilla), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_31,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.permanent_address), 1),
                              _hoisted_32,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.permanent_upazilla), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_33,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.home_district), 1),
                              _hoisted_34,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.post_code), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_35,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.ethnic), 1),
                              _hoisted_36,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.is_employee), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_37,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.is_physically), 1),
                              _hoisted_38,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.remarks), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_39,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.mobile), 1),
                              _hoisted_40,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.alt_mobile), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_41,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.email), 1),
                              _hoisted_42,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.religion), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_43,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.passing_year), 1),
                              _hoisted_44,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.monthly_income), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_45,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.hightest_class), 1),
                              _hoisted_46,
                              _hoisted_47
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_48,
                              _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.experience_year), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("table", _hoisted_53, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_54,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.course_sector), 1),
                            _hoisted_55,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.course), 1),
                            _hoisted_56,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.location), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_57,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.training_partner), 1),
                            _hoisted_58,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.training_institute), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("table", _hoisted_63, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_64,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.mother_edu), 1),
                            _hoisted_65,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.mother_occ), 1),
                            _hoisted_66,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.father_edu), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_67,
                            _hoisted_68,
                            _hoisted_69,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.family_income), 1),
                            _hoisted_70,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.sibling_no), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_71,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.family_own_home), 1),
                            _hoisted_72,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.family_own_land), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("table", _hoisted_77, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _hoisted_78,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.bank_account_type), 1),
                            _hoisted_79,
                            _hoisted_80,
                            _hoisted_81,
                            _hoisted_82
                          ]),
                          _createElementVNode("tr", null, [
                            _hoisted_83,
                            _hoisted_84,
                            _hoisted_85,
                            _createElementVNode("td", null, ": " + _toDisplayString(_ctx.traineeInfos.account_no), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}